import LS from 'local-storage'

export default {
  state: {
    character: 'mickey',
    color: 'color0',
    onboarded: false,
    stars: 0,
    starsDetails: {
      peterpan: 0
    },
    badges: {
      peterpan: false
    }
  },

  mutations: {
    saveCharacter (state, _character) {
      state.character = _character
      LS('ttp_character', _character)
    },

    saveColor (state, _color) {
      state.color = _color
      LS('ttp_color', _color)
    },

    onboarded (state) {
      state.onboarded = true
      LS('ttp_onboarded', true)
    },

    gainStars (state, _data) {
      state.stars += _data.stars
      state.starsDetails[_data.ride] += _data.stars
      // LS('ttp_stars', state.stars)
      // LS('ttp_starsDetails', state.starsDetails)

      if (state.starsDetails[_data.ride] >= 200) {
        // alert('coucou')
        state.badges[_data.ride] = true
      }
    },

    initState (state) {
      if (LS.get('ttp_color') !== undefined) {
        state.color = LS.get('ttp_color')
      }

      if (LS.get('ttp_character') !== undefined) {
        state.character = LS.get('ttp_character')
      }

      if (LS.get('ttp_onboarded') !== undefined) {
        // state.onboarded = LS.get('ttp_onboarded')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/global.js